module.exports = __webpack_public_path__ + "img/phone2.637bde37.png";